import api from '@/shared/utils/apiConfig';
import type { ClinicApiData, ClinicListItem } from '../utils/clinicForm';

export interface ClinicListParams {
  search?: string;
  status?: string;
  sort?: string;
}

interface ApiResponse<T = unknown> {
  success: boolean;
  data?: T;
  message?: string;
}

interface ApiListResponse<T = unknown> extends ApiResponse<T> {
  total?: number;
}

export const clinicAPI = {
  getAll: async (params?: ClinicListParams): Promise<ApiListResponse<ClinicListItem[]>> => {
    const response = await api.get('/clinics', { params });
    return response.data;
  },

  getOne: async (id: string): Promise<ApiResponse<ClinicApiData>> => {
    const response = await api.get(`/clinics/${id}`);
    return response.data;
  },

  getClientIp: async (): Promise<string> => {
    const response = await api.get('/clinics/client-ip');
    return response.data.data?.ip ?? '';
  },

  create: async (payload: Record<string, unknown>): Promise<ApiResponse<ClinicApiData>> => {
    const response = await api.post('/clinics', payload);
    return response.data;
  },

  update: async (
    id: string,
    payload: Record<string, unknown>
  ): Promise<ApiResponse<ClinicApiData>> => {
    const response = await api.put(`/clinics/${id}`, payload);
    return response.data;
  },

  remove: async (id: string): Promise<ApiResponse<void>> => {
    const response = await api.delete(`/clinics/${id}`);
    return response.data;
  },
};
